import { useQuery } from '@tanstack/react-query';

import { useGlobals } from '@shared/contexts/GlobalsContext';
import type { CollectInvoicesPageResponse } from '../types';

type Params = {
  merchantId: string | null | undefined;
  token: string | undefined;
  enabled: boolean;
};

export function useCollectInvoicesPage({ merchantId, token, enabled }: Params) {
  const { apiClient } = useGlobals();

  const { data, isLoading } = useQuery<CollectInvoicesPageResponse>({
    queryKey: ['collect_invoices_page', merchantId],
    queryFn: async () => {
      if (!merchantId || !token) {
        throw new Error(
          'merchantId and token are required to fetch collect invoices page'
        );
      }

      const response = await apiClient.subscriptionV3.createCollectInvoicesPage(
        { merchantId, token }
      );

      if (response.ok === false) {
        throw new Error(
          `Failed to fetch collect invoices page (${response.status})`
        );
      }

      return response.json() as Promise<CollectInvoicesPageResponse>;
    },
    enabled: enabled && Boolean(merchantId) && Boolean(token),
    gcTime: Infinity,
  });

  return { payUrl: data?.url, isLoading };
}
